import React from "react";
import { useNavigate } from "react-router-dom";
import { DEFAULT_TEMPLATE_ID } from "../export/templateRegistry";
import { log } from "../utils/logger";

interface WidescreenExportLauncherProps {
  reportId: string;
}

export const WidescreenExportLauncher: React.FC<
  WidescreenExportLauncherProps
> = ({ reportId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    log.info(
      "Launching widescreen export view",
      { reportId, template: DEFAULT_TEMPLATE_ID },
      "export",
    );
    navigate(`/export/${DEFAULT_TEMPLATE_ID}?id=${reportId}`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-exclude-from-export
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full px-5 py-3 bg-gradient-to-r from-indigo-500 to-sky-500 text-white font-semibold shadow-xl hover:shadow-2xl transition-transform hover:-translate-y-0.5"
    >
      <svg
        className="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 21h8m-4-4v4m-5-7l-3 3m0 0l3 3m-3-3h16m-4-4l3-3m0 0l-3-3m3 3H5"
        />
      </svg>
      Widescreen Export
    </button>
  );
};
